// extracted by mini-css-extract-plugin
export default {"theme-wrapper":"_3Uw49","themeWrapper":"_3Uw49","close-button":"_1sGvs","closeButton":"_1sGvs"};